<template>
  <div class="athleteList">
    <div class="search">
      <el-row :gutter="10">
        <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
          <el-select
            v-model="searchForm.provinceId"
            placeholder="请选择省"
            @change="chooseProvince($event)"
            style="width:100%"
          >
            <el-option
              v-for="item in province"
              :key="item.id"
              :label="item.area_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
          <el-select
            v-model="searchForm.cityId"
            style="width:100%"
            placeholder="请选择市"
            @change="chooseCity($event)"
          >
            <el-option v-for="item in city" :key="item.id" :label="item.area_name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
          <el-select
            v-model="searchForm.districtId"
            placeholder="请选择区"
            @change="chooseDistrict($event)"
            style="width:100%"
          >
            <el-option
              v-for="item in district"
              :key="item.id"
              :label="item.area_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="6" :sm="6" :md="4" :lg="3" style="margin-bottom: 5px;">
          <el-select v-model="searchForm.evaluator_rank" placeholder="请选择等级" style="width:100%">
            <el-option
              v-for="(item,index) in grade"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="4" style="margin-bottom: 5px;">
          <el-input placeholder="输入运动员名称" v-model="searchForm.keyword"></el-input>
        </el-col>
        <el-col :xs="16" :sm="12" :md="8" :lg="5" style="margin-bottom: 5px;">
          <el-button @click="search">
            <i class="el-icon-search"></i>
          </el-button>
          <el-button @click="clear">
            <i class="el-icon-delete"></i>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-row :gutter="20" v-if="totalCount" v-loading="loading">
      <el-col
        :xs="12"
        :sm="12"
        :md="8"
        :lg="6"
        v-for="(item,index) in data"
        :key="index"
        style="margin-bottom: 10px;"
      >
        <el-card shadow="always">
          <div class="testIndex-content">
            <router-link
              :to="{path:'/enquiry/certificateAuthenticity/athleteDetail',query:{id:item.userid,name:item.name}}"
            >
              <el-image style="width:100%; height: 200px" :src="item.photo ? imgPath+item.photo: '/image/personal/head_portrait.jpg'"></el-image>
              <p class="con">
                <label>{{item.name}}({{item.athlete_rank_name}})</label>
              </p>
              <!-- <p>{{item.address}}</p> -->
            </router-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <no-data v-else/>
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount>20"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetDistrictList,
  GetDicData
} from "@/api/admin/common.js";
import { GetAthleteList } from "@/api/admin/athletes.js";
import noData from "@/views/admin/components/noData.vue";
export default {
  components: {
    noData
  },
  data() {
    return {
      data: [],
      totalCount: 0,
      paging: {
        limit: 20,
        page: 1
      },
      loading: false,
      imgPath: window.apiObj.apiUrl,
      searchForm: {},
      grade: [],
      province: [],
      city: [],
      district: []
    };
  },
  watch: {
    "searchForm.provinceId"(val) {
      GetDistrictList({ parent_id: val }).then(data => {
        this.city = data.data.result.items;
        this.searchForm.cityId = "";
        this.searchForm.districtId = "";
      });
    }
  },
  created() {
    this.getList();
    this.getDistrictList();
  },
  methods: {
    getList() {
      // 运动员列表
      this.loading = true;
      GetAthleteList(Object.assign(this.searchForm, this.paging))
        .then(data => {
          var list = data.data.result;
          if (list) {
            this.data = list.items;
            this.totalCount = list.totalCount;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 运动员列表分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      this.getList();
    },
    // 运动员列表搜索
    search() {
      if (
        this.searchForm.provinceId == "" ||
        this.searchForm.cityId == "" ||
        this.searchForm.districtId == "" ||
        this.searchForm.evaluator_rank == "" ||
        this.searchForm.keyword == ""
      ) {
        this.handleCurrentChange(1);
      } else {
        this.getList();
      }
    },
    clear() {
      this.city = [];
      this.district = [];
      this.searchForm = {};
      this.getList();
    },
    getDistrictList() {
      // 区域列表
      GetDistrictList({ parent_id: "-1" }).then(data => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
      GetDicData({ classCode: "certificate_grade" }).then(data => {
        if (data.data.result) {
          for(let i=data.data.result.length-1;i>=0;i--){
              if(data.data.result[i].value=='31'||data.data.result[i].value=='32'||data.data.result[i].value=='33'){
                  data.data.result.splice(i,1)
              }
          }
          this.grade = data.data.result;
        }
      });
    },
    chooseProvince(item) {
      GetDistrictList({ parent_id: item }).then(data => {
        this.city = data.data.result.items;
      });
    },
    chooseCity(item) {
      GetDistrictList({ parent_id: item }).then(data => {
        this.searchForm.districtId = "";
        this.district = data.data.result.items;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    }
  },
  beforeDestroy() {
    this.searchBus.$off("SearchData");
  }
};
</script>

<style lang="less" scoped>
.athleteList {
  .el-card__body {
    padding: 0;
    .con {
      position: relative;
      border-bottom: 1px solid #c4c4c4;
      color: #4e4e4e;
      text-align: center;
      padding: 20px 0;
      .badge {
        position: absolute;
        top: 8px;
        left: 13px;
        width: 23px;
        height: 23px;
        margin-right: 3px;
      }
      label {
        position: absolute;
        top: 10px;
        left: 42px;
      }
    }
    p {
      text-align: center;
      padding: 9px 0 15px 0;
      color: #000000;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 767px) {
  .trainlist {
    .el-card__body {
      .con {
        padding: 28px 0;
      }
    }
  }
}
</style>
